import { render, staticRenderFns } from "./ChapterDetail.vue?vue&type=template&id=d60af116&scoped=true&"
import script from "./ChapterDetail.vue?vue&type=script&lang=js&"
export * from "./ChapterDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChapterDetail.vue?vue&type=style&index=0&id=d60af116&lang=less&scoped=true&"
import style1 from "./ChapterDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60af116",
  null
  
)

export default component.exports